import React from "react";

import "./index.scss";

const RequiredMarker = () => {
  return <span className="required-marker">*</span>;
};

export default RequiredMarker;
